<script setup>
import { useI18n } from 'vue-i18n';
import AiPanel from '../../captain/assistants/ai_panel/Index.vue';
import ReportSourceNote from './components/ReportSourceNote.vue';

// Aba "IA" da casa dos relatorios: o Painel da IA, o mesmo que vive dentro do
// Captain. Nada foi reescrito; `embedded` so tira o cabecalho e a rolagem do
// PageLayout, que a casa ja tem.
//
// A nota de fonte diz que este painel conta o que a IA escreveu e leva para
// a aba Robo, que conta outra coisa (eventos de atendimento automatico).
const { t } = useI18n();
</script>

<template>
  <AiPanel embedded>
    <template #source-note>
      <ReportSourceNote
        class="mt-3"
        :text="t('REPORT.SOURCE_NOTE.AI_PANEL')"
        :link-label="t('REPORT.SOURCE_NOTE.AI_PANEL_LINK')"
        area-id="atendimento"
        tab-id="robo"
      />
    </template>
  </AiPanel>
</template>
